import React from 'react';
import { ArrowRight, Eye, Target } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const VisionMissionSection = () => {
  const { t } = useTranslation();
  
  const scrollToContact = (e) => {
    e.preventDefault();
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };
  

  return (
    <section className="aped-vision-mission-section">
      <div className="aped-vision-mission-content-wrapper">
        <h2 className="aped-vision-mission-title">{t('visionMission.title')}</h2>
        <div className="aped-vision-mission-content">
          <div className="aped-vision-mission-card">
            <div className="aped-vision-mission-card-header">
              <Eye className="aped-vision-mission-icon" size={24} />
              <h3>{t('visionMission.vision.title')}</h3>
            </div>
            <p className="aped-vision-mission-description">
              {t('visionMission.vision.description')}
            </p>
          </div>
          <div className="aped-vision-mission-card">
            <div className="aped-vision-mission-card-header">
              <Target className="aped-vision-mission-icon" size={24} />
              <h3>{t('visionMission.mission.title')}</h3>
            </div>
            <p className="aped-vision-mission-description">
              {t('visionMission.mission.description')}
            </p>
          </div>
        </div>
        <div className="aped-vision-mission-cta-container">
          <button className="aped-vision-mission-cta-button" onClick={scrollToContact}>
            {t('visionMission.cta')}
            <ArrowRight className="aped-vision-mission-button-icon" size={20} />
          </button>
        </div>
      </div>
      <style jsx>{`
        .aped-vision-mission-section {
          position: relative;
          padding: 6rem 2rem;
          background-color: #f8f9fa;
          overflow: hidden;
          font-family: 'Inter', sans-serif;
        }

        .aped-vision-mission-content-wrapper {
          max-width: 1200px;
          margin: 0 auto;
          position: relative;
          z-index: 2;
        }

        .aped-vision-mission-title {
          font-size: 2.5rem;
          color: #1b1f3a;
          margin-bottom: 2rem;
          text-align: center;
          position: relative;
        }

        .aped-vision-mission-title::after {
          content: '';
          display: block;
          width: 50px;
          height: 3px;
          background-color: #b4a35e;
          margin: 1rem auto 0;
        }

        .aped-vision-mission-content {
          display: flex;
          gap: 2rem;
          margin-bottom: 3rem;
        }

        .aped-vision-mission-card {
          flex: 1;
          background: white;
          border-radius: 15px;
          padding: 1.5rem;
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          display: flex;
          flex-direction: column;
        }

        .aped-vision-mission-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 6px 24px rgba(0, 0, 0, 0.15);
        }

        .aped-vision-mission-card-header {
          display: flex;
          align-items: center;
          margin-bottom: 1rem;
        }

        .aped-vision-mission-icon {
          color: #b4a35e;
          margin-right: 0.5rem;
        }

        .aped-vision-mission-card h3 {
          font-size: 1.3rem;
          color: #1b1f3a;
          position: relative;
          padding-bottom: 0.5rem;
          margin: 0;
        }

        .aped-vision-mission-card h3::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 40px;
          height: 2px;
          background-color: #f39c12;
        }

        .aped-vision-mission-description {
          font-size: 1.1rem;
          line-height: 1.6;
          color: #34495e;
          text-align: justify;
          flex-grow: 1;
        }

        .aped-vision-mission-cta-container {
          text-align: center;
        }

        .aped-vision-mission-cta-button {
          background-color: #b4a35e;
          color: white;
          font-size: 1.1rem;
          font-weight: 600;
          padding: 12px 24px;
          border: none;
          border-radius: 50px;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          transition: all 0.3s ease;
        }

        .aped-vision-mission-cta-button:hover {
          background-color: #c9b87d;
          transform: translateY(-2px);
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        }

        .aped-vision-mission-button-icon {
          margin-left: 8px;
          transition: transform 0.3s ease;
        }

        .aped-vision-mission-cta-button:hover .aped-vision-mission-button-icon {
          transform: translateX(4px);
        }

        @media (max-width: 768px) {
          .aped-vision-mission-section {
            padding: 4rem 1rem;
          }

          .aped-vision-mission-content {
            flex-direction: column;
          }

          .aped-vision-mission-title {
            font-size: 2rem;
          }

          .aped-vision-mission-description {
            font-size: 1rem;
          }

          .aped-vision-mission-cta-button {
            font-size: 1rem;
            padding: 10px 20px;
          }
        }
      `}</style>
    </section>
  );
};

export default VisionMissionSection;